import React from "react";
import Banner from "./01_banner";
import Fellowship from "./03_fellowship";
import JoinUs from "./04_joinUs";
import useGSAP from "hooks/useGsap";
import Founder from "./06_founder";
import Impact from "./09_impact";
import JoinFamily from "./11_joinFamily";
import { Helmet } from "react-helmet-async";
import Vision from "./05_vision";
import SuccessStories from "./08_successStories";
import Resources from "./12_resources";

const Nurturing = React.lazy(() => import('./02_about'));
const Sector = React.lazy(() => import('./sectors'));
const BuddhaFellowship = React.lazy(() => import('./07_buddhaFellowship'));
const CaseStudyHome = React.lazy(() => import('molecules/caseStudiesHome'));
const Supporters = React.lazy(() => import('./10_supporters'));

const Home = () => {
  useGSAP(".home-wrapper");
  return (
    <>
      <Helmet>
        <title> The Buddha Institute</title>
        <meta
          name="description"
          content="The Buddha Institute is a field-building platform empowering development entrepreneurs to serve marginalized communities."
        />
        <meta
          name="keywords"
          content="Buddha Institute, development entrepreneurship, social impact, mentorship, Fellowship"
        />
        <meta name="author" content="The Buddha Institute" />
        <meta
          property="og:title"
          content="The Buddha Institute – Empowering Development Entrepreneurs"
        />
        <meta
          property="og:description"
          content="A platform supporting development entrepreneurs in creating social impact for marginalized communities."
        />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="./final-logo-new.svg" />
        <meta property="og:image" content="./final-logo-new.svg" />

        {/* Twitter Card */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="The Buddha Institute – Empowering Development Entrepreneurs"
        />
        <meta
          name="twitter:description"
          content="Support for social entrepreneurship—The Buddha Institute connects mentors, funding, and community to enable change."
        />
        <meta name="twitter:image" content="./final-logo-new.svg" />
        <link rel="canonical" href="https://thebuddhainstitute.org/" />

        <meta charSet="UTF-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
      </Helmet>
      <div className="home-wrapper">
      <Banner />
        <Nurturing />
        <Fellowship />
        <JoinUs />
        <Vision />
       <Founder />
       <BuddhaFellowship />
        <Sector />
        <SuccessStories />  
        
 <CaseStudyHome
          title="Buddha Fellow highlights"
          buttonText="Become a Buddha Fellow"
          paragraphs={[
            "Our Buddha Fellows overcome on-the-ground challenges with immense passion and resilience. The result — increased dignity and labor force participation.",
            "Select cases of transformation being driven by our <b>Buddha Fellows.</b>",
          ]}
        />  
      <Impact /> 

        <Resources />
 <JoinFamily />  
<Supporters />  
      </div>
    </>
  );
};

export default Home;
